import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { DeprecatedLinkButton } from '../deprecated-buttons/deprecated-link-button/link-button';
export var InfoBoxKey = 'info-box';
var InfoBox = /** @class */ (function (_super) {
    __extends(InfoBox, _super);
    function InfoBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            expanded: !!_this.props.startExpanded
        };
        _this.toggleExpand = function () { return _this.setState({ expanded: !_this.state.expanded }); };
        return _this;
    }
    InfoBox.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        var hasTitle = !!props.title;
        var classNames = namespacedClassnames(InfoBoxKey, props.className, {
            'has-title': hasTitle
        });
        var toggleExpandText = state.expanded ? props.showLessText : props.showMoreText;
        var maybeExpandBtn = props.additionalBody ? (React.createElement(DeprecatedLinkButton, { className: 'toggle-expand', onClick: this.toggleExpand }, toggleExpandText)) : null;
        return (React.createElement("div", { className: classNames },
            hasTitle ? React.createElement("div", { className: 'title-container' }, props.title) : null,
            React.createElement("div", { className: 'body-container' },
                props.mainBody,
                state.expanded ? props.additionalBody : null,
                maybeExpandBtn)));
    };
    return InfoBox;
}(React.PureComponent));
export { InfoBox };
//# sourceMappingURL=index.js.map